module.exports = __webpack_public_path__ + "img/About_Desktop_06.2de722d9.jpg";